if (!customElements.get('back-in-stock-notification')) {
  class BackInStockNotificationForm extends ModalDialog {

    constructor(){
      super()
      window.initScriptOnDemand(this, this.init.bind(this));
    }

    init(){
      this.form = this.querySelector("form");
      if(!this.form) return;
      
      document.addEventListener('click', this.handleClickTrigger.bind(this));
      
      this.form.addEventListener("submit", this.submit.bind(this));
      this.submitButton = this.querySelector('form [data-back-in-stock-submit]');
      this.message = this.querySelector('form [data-back-in-stock-results]');
    }

    submit(e){
      e.preventDefault()
      if (typeof BIS === 'undefined') return;
      if(this.disabled) return;

      this.disabled = true;
      this.setSubmitButton(true)

      const formData = new FormData(this.form);
      const email = formData.get('email');

      BIS.create(
          email,
          this.variantId,
          this.productId
      ).then(res => {
          if (res.status == 'OK') {
              this.setSubmitButton(true, "Subscribed!")
              this.setMessage(res.message, true)
          } else {
              this.reset();
              const errors = Object.values(res.errors).join(" ")
              this.setMessage(errors, false)
          }
      });
    }

    handleClickTrigger(event){
      const target = event.target.closest('[data-back-in-stock-open]');
      if (target) {
        event.preventDefault();
        this.show(target);
      }
    }

    show(opener){
      this.reset(true)

      // Get product/variant info from closest product form
      const parentForm = opener.closest('product-form');

      this.productId = parentForm?.querySelector('form input[name="product-id"]')?.value
      this.variantId = parentForm?.querySelector('form input[name="id"]')?.value

      super.show(opener);
    }

    reset(clearMessage = false){
      // Reset the form
      this.disabled = false;
      this.setSubmitButton(false, "Subscribe")

      if(clearMessage){
        this.setMessage(undefined)
      }
    }

    setSubmitButton(disabled = undefined, content = undefined){
      if(this.submitButton){
        if(disabled !== undefined){
          this.submitButton.disabled = disabled;
        }

        if(content !== undefined){
          this.submitButton.textContent = content;
        }        
      }
    }

    setMessage(content, success){
      if(this.message){
        if(!content){
          this.message.classList.add("visibility-hidden");
        } else {
          this.message.textContent = content;
          this.message.classList.remove("visibility-hidden");
        }

        if(!success){
          this.message.style.color = 'var(--color-error)'
        } else {
          this.message.style.color = 'var(--color-success)'
        }
      }      
    }
  }

  customElements.define('back-in-stock-notification-form', BackInStockNotificationForm);
}
